/* eslint-disable react/no-unused-class-component-methods */
/* eslint-disable prefer-destructuring */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-useless-escape */
/* eslint-disable consistent-return */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
/* eslint-disable array-callback-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/self-closing-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import Skeleton from 'react-loading-skeleton';
import {
  getTourDetails,
  getTourFlights,
  getHotelDetailsWithReviews,
  applyCoupon,
  getOperatorInfo,
} from '../../Utils/RestUtils';
import FlightRoundTrip from '../FlightRoundTrip/FlightRoundTrip';
import PriceText from '../PriceText/PriceText';
import { ORDER_DETAILS_TITLE } from '../../Utils/Constants/SEO';
import './css/OrderDetails.css';
import {
  INCORRECT_EMAIL_FORMAT,
  CHOOSE_ANOTHER,
  YOUR_EMAIL,
  CALL_BACK_PHONE,
  BOOK,
  TOUR_PRICE,
  FUEL_CHARGE,
  I_HAVE_PROMOCODE,
  ENTER_PROMO,
  ADD_NOTE,
  YOUR_NOTE,
  APPLY,
  PROMO_CODE_ERROR,
  FLIGHT_INSURANCE,
  INSUTANCE_MANAGER,
  INSURANCE_BEFORE_DAYS,
  BEFORE_FLIGHT,
  SPLIT_PRICE,
  PAY_NOW,
  TOUR_DATA_OUTDATED,
  ONLIBE_BOOK_NOT_AVAIL,
  CONTACT_US1,
  AND_WE_CHECK,
  MAIN_PAGE,
  SLASH_DELIMITER,
  TOUR_IN,
  ABOUT_HOTEL,
  REVIEWS,
  MEAL,
  PLACEMENT,
  ROOM_TYPE,
  TOUR_DETAILS,
  PAYMENT,
  CONTACT_INFO,
  OPERATOR,
  PROGRAMM,
  TOUR_INCLUDED,
  TOUR_INC_AVIA,
  TOUR_INC_HOTEL,
  TOUR_INC_MED,
  TOUR_INC_TRANSFER,
  TOTAL,
  PAY_REST,
  BOOK_TOUR,
  FLIGHT_INFO,
  DISCOUNT,
  PROMO_CODE_COUNTRY_ERROR,
} from '../../Utils/Constants/GlobalConstants';
import { TOUR_ID } from '../../Utils/Constants/urlParams';
import FlightLoader from '../FlightRoundTrip/FlightLoader/FlightLoader';
import {
  getPrice,
  getPriceSplit,
  isFlightInsuranceAvailable,
  getInsuranceBeforeDays,
} from '../../Utils/Constants/PriceUtil';
import { getDayWordByQuantity } from '../../Utils/DateUtil';
import { getOrderPayload } from '../../Utils/OrderUtil';
import { ReactComponent as ToggleRight } from '../../images/switch-selected-r.svg';
import { ReactComponent as ToggleLeft } from '../../images/switch-default-r.svg';
import { isCheapestFlight } from '../../Utils/FlightUtils';
import {
  firstLetterInUpperCase,
  getDayText,
  getNightsText,
  getTouristsTextActualiz,
  formatPrice,
} from '../../Utils/CommonUtils';
import { changeContactModalVisible } from '../../DataStore/actions/searchFormActions';
import { ReactComponent as NoHotel } from '../../images/hotel-r.svg';
import { ReactComponent as OrangeStar } from '../../images/orange-star-r.svg';
import { meals } from '../../Utils/Constants/Meals';
import { ReactComponent as GrayCalendar } from '../../images/gray-calendar-r.svg';
import { ReactComponent as GrayPerson } from '../../images/gray-person-r.svg';
import { ReactComponent as DefaultCheck } from '../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../images/active-check-r.svg';
import { ReactComponent as ArrowTop } from '../../images/black-arrow-top-r.svg';
import HotelReviewsModal from '../Modals/HotelReviewsModal/HotelReviewsModal';
import AboutHotelModal from '../Modals/AboutHotelModal/AboutHotelModal';
import { ReactComponent as Close } from '../../images/close-r.svg';
import { ReactComponent as GrayFlight } from '../../images/gray-flight-r.svg';
import FlightsModal from '../Modals/FlightsModal/FlightsModal';
import FlightsDetailsModal from '../Modals/FlightsDetailsModal/FlightsDetailsModal';
import { ReactComponent as GreenCross } from '../../images/green-cross-r.svg';
import NoResults from '../../images/no-results.png';

const mapStateToProps = (state) => ({ ...state });

class OrderDetails extends React.Component {
  constructor(props) {
    super(props);

    this.flightsContainer = React.createRef();
    this.reviewModalNode = React.createRef();
    this.reviewModaButtomNode = React.createRef();
    this.ablutHotelModalNode = React.createRef();
    this.ablutHotelButtomNode = React.createRef();
    this.flightsModalNode = React.createRef();
    this.flightsModalScrollNode = React.createRef();
    this.flightsButtomNode = React.createRef();
    this.flightDetailModalNode = React.createRef();
    this.flightFromDetButtomNode = React.createRef();
    this.flightToDetButtomNode = React.createRef();

    this.state = {
      acualizationData: {},
      actulizationLoaded: false,
      actulizationLoadedSuccess: false,

      hotelDetails: {},
      hotelDetailsLoaded: false,
      hotelDetailsSuccess: false,

      priceCurrency: '',

      flights: [],

      ticketsSuccess: false,
      ticketsLoaded: false,

      noFlight: false,
      noMeal: false,
      noMedInsurance: false,
      noTransfer: false,
      selectedFlight: {},
      isAllFlightsVisible: false,
      tourInfo: {},
      insuranceChecked: true,

      promoCodeInput: '',
      promoCode: {},
      isPromoVisible: false,
      promoCodeError: '',
      isPromoApplied: false,

      tourNote: '',
      tourNoteVisible: false,

      splitPrice: 100,
      operatorInfo: {},

      isDisabled: false,
      priceData: {},
      phoneValue: '',
      isPhoneValid: false,
      emailValue: '',
      isEmailValid: false,
      emailWasFocused: false,
      phoneWasFocused: false,
      emailErrorMessage: '',
      phoneErrorMessage: '',
      tourPricePayload: {},
      hotelId: '',
      adults: '',
      kids: '',
      taRaiting: '',
      taReviews: '',
      dataValid: true,
      selectedRoundTripId: '',
      isSingleRoadTripOption: false,
      isOnlineBookAvailable: false,
      isReviewsVisible: false,
      reviews: [],
      isAboutHotelVisible: false,
      scrollbarWidth: 0,
      selectedAboutHotelCategory: 0,
      tabletDetailsHeight: 0,
      isTableDetailsVisible: false,
      isFlightsModalVisible: false,
      isFlightDetModalVisible: false,
      isToDetFlight: false,
    };
  }

  componentDidMount() {
    // screen withd
    this.timeout(500).then(() => {
      const scrollWidth =
        window.innerWidth - document.documentElement.clientWidth;

      this.setState({
        scrollbarWidth: scrollWidth,
        tabletDetailsHeight: window.innerHeight * 0.9,
      });
    });

    const { location } = this.props;

    const queryParameters = new URLSearchParams(location.search);

    let tourId;
    if (queryParameters.has(TOUR_ID) && queryParameters.get(TOUR_ID) !== '') {
      if (!isNaN(queryParameters.get(TOUR_ID))) {
        tourId = queryParameters.get(TOUR_ID);
        this.setState({ tourId });
      }
    }

    if (tourId) {
      this.fetchTourDetails(tourId);
      this.fetchTourFlights(tourId);
    } else {
      this.setState({ dataValid: false });
    }
  }

  async timeout(delay) {
    return new Promise((res) => {
      setTimeout(res, delay);
    });
  }

  fetchTourDetails = (id) => {
    getTourDetails(id)
      .then((response) => {
        if (response && response.data) {
          const { data } = response;
          if (data.data.success === 0) {
            this.setState({ dataValid: false });
          } else {
            const acualizationData = data.data.tour;

            this.setState({
              acualizationData,
              actulizationLoadedSuccess: true,
              priceCurrency: acualizationData.currency,
            });

            if (
              acualizationData.onrequest != 1 ||
              acualizationData.flightstatus != 1 ||
              acualizationData.hotelstatus != 1
            ) {
              this.setState({ isOnlineBookAvailable: true });
            }

            this.fetchHotelDetails(acualizationData.hotelcode);
            this.fetchOperatorInfo(acualizationData.operatorcode);
          }
        }
      })
      .catch(() => {
        this.setState({ dataValid: false });
      })
      .finally(() => {
        this.setState({ actulizationLoaded: true });
      });
  };

  fetchHotelDetails(hotelCode) {
    getHotelDetailsWithReviews(hotelCode)
      .then((response) => {
        if (response && response.data) {
          const details = response.data;

          let reviews = [];
          if (details && details.reviews && details.reviews.length > 0) {
            reviews = details.reviews.map((e, index) => {
              let short;
              let long;
              let isLong = false;

              if (e.content.length > 200) {
                short = e.content.substring(0, 200);
                short += '...';
                long = e.content;
                isLong = true;
              } else {
                short = e.content;
              }

              return { ...e, short, long, isLong, showLong: false, id: index };
            });
          }

          this.setState({
            hotelDetailsSuccess: true,
            hotelDetails: details,
            reviews,
          });
        }
      })
      .catch(() => {})
      .finally(() => {
        this.setState({
          hotelDetailsLoaded: true,
        });
      });
  }

  fetchOperatorInfo(operatorId) {
    getOperatorInfo(operatorId)
      .then((response) => {
        this.setState({ operatorInfo: response.data });
      })
      .catch();
  }

  fetchTourFlights = (id) => {
    getTourFlights(id)
      .then((response) => {
        if (response && response.data) {
          const { data } = response;
          if (!data.iserror && data.flights && data.flights.length > 0) {
            this.setState({
              tourInfo: data.tourinfo,
            });

            if (data.tourinfo) {
              const { flags } = data.tourinfo;

              if (flags) {
                const { noflight, nomeal, nomedinsurance, notransfer } = flags;

                if (noflight) {
                  this.setState({ noFlight: true });
                }

                if (nomeal) {
                  this.setState({ noMeal: true });
                }

                if (nomedinsurance) {
                  this.setState({ noMedInsurance: true });
                }

                if (notransfer) {
                  this.setState({ noTransfer: true });
                }
              }
            }

            if (data.flights.length === 1) {
              const fl = data.flights[0];
              const { currency } = fl.price;

              this.setState({
                selectedFlight: data.flights[0],
                ticketsSuccess: this.validateTicket(data.flights[0]),
                flights: data.flights,
                priceCurrency: currency,
              });
            } else {
              const defaultFlightArray = data.flights.filter(
                (e) => e.isdefault === true,
              );

              if (defaultFlightArray.length > 0) {
                const defaultFlight = defaultFlightArray[0];
                const { currency } = defaultFlight.price;

                this.setState({
                  selectedFlight: defaultFlight,
                  ticketsSuccess: this.validateTicket(defaultFlight),
                  flights: data.flights,
                  priceCurrency: currency,
                });
              }
            }
          } else {
            this.setState({
              ticketsSuccess: false,
            });
          }
        }
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ ticketsLoaded: true });
      });
  };

  validateTicket = (ticket) =>
    ticket &&
    ticket.price &&
    ticket.price.currency &&
    ticket.price.value &&
    // forward
    ticket.forward &&
    ticket.forward.length > 0 &&
    // forward departure
    ticket.forward[0].departure &&
    ticket.forward[0].departure.date &&
    ticket.forward[0].departure.time &&
    ticket.forward[0].departure.port &&
    ticket.forward[0].departure.port.id &&
    ticket.forward[0].departure.port.name &&
    ticket.forward[0].departure.port.timeZone &&
    // forward arrival
    ticket.forward[0].arrival &&
    ticket.forward[0].arrival.date &&
    ticket.forward[0].arrival.time &&
    ticket.forward[0].arrival.port &&
    ticket.forward[0].arrival.port.id &&
    ticket.forward[0].arrival.port.name &&
    ticket.forward[0].arrival.port.timeZone &&
    // backward
    ticket.backward &&
    ticket.backward.length > 0 &&
    // backward departure
    ticket.backward[0].departure &&
    ticket.backward[0].departure.date &&
    ticket.backward[0].departure.time &&
    ticket.backward[0].departure.port &&
    ticket.backward[0].departure.port.id &&
    ticket.backward[0].departure.port.name &&
    ticket.backward[0].departure.port.timeZone &&
    // backward arrival
    ticket.backward[0].arrival &&
    ticket.backward[0].arrival.date &&
    ticket.backward[0].arrival.time &&
    ticket.backward[0].arrival.port &&
    ticket.backward[0].arrival.port.id &&
    ticket.backward[0].arrival.port.name &&
    ticket.backward[0].arrival.port.timeZone;

  // --------------------------

  handleEmailChange = (e) => {
    const emailValue = e.target.value;
    this.setState({ emailValue });

    if (this.emailValidation(emailValue, false)) {
      this.setState({ isEmailValid: true });
    } else {
      this.setState({ isEmailValid: false });
    }
  };

  emailValidation = (emailValue, blur) => {
    const { emailWasFocused } = this.state;
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!emailValue || regex.test(emailValue) === false) {
      if (blur || emailWasFocused) {
        this.setState({ emailErrorMessage: INCORRECT_EMAIL_FORMAT });
      }
      return false;
    }

    this.setState({ emailErrorMessage: '' });
    return true;
  };

  handleEmailInputBlur = () => {
    const { emailValue } = this.state;
    if (emailValue.length > 0) {
      if (this.emailValidation(emailValue, true)) {
        this.setState({ isEmailValid: true });
      } else {
        this.setState({ isEmailValid: false });
      }
      this.setState({ emailWasFocused: true });
    }
  };

  handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    this.setState({ phoneValue });

    if (this.phoneValidation(phoneValue, false)) {
      this.setState({ isPhoneValid: true });
    } else {
      this.setState({ isPhoneValid: false });
    }
  };

  phoneValidation = (phoneValue, blur) => {
    const { phoneWasFocused } = this.state;
    // eslint-disable-next-line no-useless-escape
    const regex = /^[\+]?[0-9]{12}$/i;
    if (!phoneValue || regex.test(phoneValue) === false) {
      if (phoneWasFocused || blur) {
        this.setState({
          phoneErrorMessage: 'Неверный формат. Пример: +375291112233',
        });
      }
      return false;
    }

    this.setState({ phoneErrorMessage: '' });
    return true;
  };

  handlePhoneInputBlur = () => {
    const { phoneValue } = this.state;
    if (phoneValue.length > 0) {
      if (this.phoneValidation(phoneValue, true)) {
        this.setState({ isPhoneValid: true });
      } else {
        this.setState({ isPhoneValid: false });
      }

      this.setState({ phoneWasFocused: true });
    }
  };

  handleCheckoutClick = (isTabletClick) => {
    const { navigate } = this.props;
    const {
      phoneValue,
      emailValue,
      acualizationData,
      tourNote,
      tourInfo,
      promoCode,
      isPromoApplied,
      splitPrice,
      tourId,
      selectedFlight,
      priceCurrency,
    } = this.state;
    const insuranceChecked = this.isInsuranceChecked();

    if (isTabletClick) {
      this.handleBottomSheetClick();
    }

    const order = getOrderPayload({
      acualizationData,
      selectedFlight,
      tourInfo,
      insuranceChecked,
      promoCode,
      isPromoApplied,
      splitPrice,
      priceCurrency,
      tourId,
      phoneNumber: phoneValue,
      email: emailValue,
      note: tourNote,
    });

    navigate('/checkout', {
      state: { order, acualizationData, selectedFlight },
    });
  };

  selectRoundTrip = (fl) => {
    this.setState({
      selectedFlight: fl,
    });

    this.handleFlightsModalClick();
  };

  renderTickets = (trips) => {
    const { ticketsSuccess, selectedFlight, flights } = this.state;

    if (ticketsSuccess) {
      return (
        <div>
          <div>
            <FlightRoundTrip
              flight={selectedFlight}
              detailsClick={this.handleFlightDetailsModalClick}
              fromNode={this.flightFromDetButtomNode}
              toNode={this.flightToDetButtomNode}
              cheapest={isCheapestFlight(selectedFlight, flights)}
            />
          </div>
          {trips.length > 1 && (
            <div className="od_choose_another_w">
              <button
                type="button"
                className="dbm_text_16 od_choose_another_button"
                onClick={this.handleFlightsModalClick}
                ref={(node) => {
                  this.flightsButtomNode.current = node;
                }}
              >
                {CHOOSE_ANOTHER}
              </button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div className="od_flight_info_wrapper">
          <div className="od_flight_info_text">
            <GrayFlight className="od_flight_info_ico" />
            <div className="bm_text_22">{FLIGHT_INFO}</div>
          </div>
          <button
            type="button"
            className="od_contact_us blue_button wr_text_16"
            onClick={this.handleContanctUsModal}
          >
            {CONTACT_US1}
          </button>
        </div>
      );
    }
  };

  getCheapestPrice() {
    const { flights } = this.state;

    let cheapestPrice;
    let isPriceInited = false;

    flights.forEach((e) => {
      if (e.price && e.price.value) {
        if (!isPriceInited) {
          cheapestPrice = e.price.value;
          isPriceInited = true;
        }

        if (e.price.value < cheapestPrice) {
          cheapestPrice = e.price.value;
        }
      }
    });

    return cheapestPrice;
  }

  renderAddPayments = () => {
    const content = [];
    const { tourInfo, priceCurrency } = this.state;

    if (tourInfo && tourInfo.addpayments && tourInfo.addpayments.length > 0) {
      tourInfo.addpayments.forEach((e, index) => {
        content.push(
          <div key={index} className="od_price_line od_add_payment">
            <div className="od_price_line_col bm_text_16">{e.name}</div>
            <div className="od_bold br_text_16">
              <PriceText text={`${e.amount} ${priceCurrency}`} />
            </div>
          </div>,
        );
      });
    }

    return content;
  };

  getFuelCharge = () => {
    const { selectedFlight } = this.state;

    if (selectedFlight && selectedFlight.fuelcharge) {
      const { value, currency } = selectedFlight.fuelcharge;
      return `${value} ${currency}`;
    }

    return 0;
  };

  handlePromocodeInput = (value) => {
    const val = value.target.value;
    this.setState({ promoCodeInput: val, promoCodeError: '' });
  };

  applyCoupon = () => {
    const { promoCodeInput, acualizationData } = this.state;
    const { departurecode } = acualizationData;

    if (promoCodeInput.length > 0) {
      // only from Minsk
      if (
        departurecode == 57 || // Minsk
        departurecode == 71 || // Vitebsk
        departurecode == 69 || // Gomel
        departurecode == 70 // Brest
      ) {
        applyCoupon(promoCodeInput)
          .then((response) => {
            if (response && response.data && response.data.name) {
              this.setState({
                promoCode: response.data,
                isPromoApplied: true,
              });
            } else {
              this.setState({ promoCodeError: PROMO_CODE_ERROR });
            }
          })
          .catch(() => {});
      } else {
        this.setState({ promoCodeError: PROMO_CODE_COUNTRY_ERROR });
      }

      this.setState({ promoCodeInput: '' });
    }
  };

  getSplitPrice = (totalPrice) => {
    const { splitPrice } = this.state;

    return Math.ceil(totalPrice * (splitPrice / 100));
  };

  getSplitRestPrice = (totalPrice) => {
    const { splitPrice } = this.state;

    if (splitPrice === 100) {
      return 0;
    } else {
      return Math.ceil(totalPrice - totalPrice * (splitPrice / 100));
    }
  };

  renderPriceSplit = (items, splitPrice) =>
    items.map((item, index) => (
      <button
        type="button"
        key={index}
        onClick={() => this.setState({ splitPrice: item })}
        className={
          splitPrice === item
            ? 'od_price_split_item od_price_item_selected'
            : 'od_price_split_item od_price_item_not_selected'
        }
      >
        <div>{`${item}%`}</div>
      </button>
    ));

  renderInsuranceBeforeDays = () => {
    const { acualizationData, operatorInfo } = this.state;
    const beforeDays = getInsuranceBeforeDays(acualizationData, operatorInfo);

    return (
      beforeDays > 0 && (
        <div className="gm_text_14 od_insurance_before_days">
          {`${INSURANCE_BEFORE_DAYS} ${beforeDays} ${getDayWordByQuantity(
            beforeDays,
          )} ${BEFORE_FLIGHT}`}
        </div>
      )
    );
  };

  handleContanctUsModal = () => {
    const { changeContactModalVisible: changeContactModalVisibleAction } =
      this.props;

    changeContactModalVisibleAction(true);
    document.body.style.overflow = 'hidden';
  };

  renderHotelCategory = (starsCount) => {
    const content = [];
    for (let i = 0; i < starsCount; i++) {
      content.push(<OrangeStar key={i} className="tr_category_star" />);
    }
    return content;
  };

  getHotelLocationName = (hotel) => {
    let result = '';

    if (hotel.region && hotel.region.length > 0) {
      result += `${hotel.region}, `;
    }

    if (hotel.country && hotel.country.length > 0) {
      result += `${hotel.country}`;
    }

    return result;
  };

  getRatingColor = (rating) => {
    let result = '';
    if (rating <= 2) {
      result = 'tr_rating_red';
    } else if (rating <= 3.9) {
      result = 'tr_rating_yellow';
    } else {
      result = 'tr_rating_green';
    }

    return result;
  };

  getMeal = (acualizationData) => {
    let result = '';

    if (acualizationData.mealcode) {
      const filteredMeal = meals.filter(
        (e) => e.id === acualizationData.mealcode,
      );

      if (filteredMeal.length > 0) {
        result = filteredMeal[0].russianfull;
      } else {
        result = acualizationData.meal;
      }
    } else {
      result = acualizationData.meal;
    }

    return result;
  };

  isRegular = (data) => data.regular && data.regular == 1;

  // Hidden insurance (disabled for operator / departure / country) is not counted
  isInsuranceChecked = () => {
    const { insuranceChecked, acualizationData, operatorInfo } = this.state;

    return (
      insuranceChecked &&
      isFlightInsuranceAvailable(acualizationData, operatorInfo)
    );
  };

  handleReviewModalClick = () => {
    const { isReviewsVisible, reviews, scrollbarWidth } = this.state;
    const newReviewState = reviews.map((e) => ({ ...e, showLong: false }));

    if (!isReviewsVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleReviewModalOutsideClick,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleReviewModalOutsideClick,
        false,
      );
    }

    this.setState({
      isReviewsVisible: !isReviewsVisible,
      reviews: newReviewState,
    });
  };

  handleReviewModalOutsideClick = (e) => {
    const className = e.target.className;
    const isSVG =
      e.target.getAttribute('viewBox') !== null ||
      e.target.getAttribute('fill');
    if (
      this.reviewModaButtomNode.current.contains(e.target) ||
      this.reviewModalNode.current.contains(e.target) ||
      className === 'hotel_rev_ream_more dbr_text_16' ||
      isSVG
    ) {
      return;
    }

    this.handleReviewModalClick();
  };

  handleAboutHotelModalClick = () => {
    const { isAboutHotelVisible, reviews, scrollbarWidth } = this.state;
    const newReviewState = reviews.map((e) => ({ ...e, showLong: false }));

    if (!isAboutHotelVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleAboutHotelModalOutsideClick,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleAboutHotelModalOutsideClick,
        false,
      );
    }

    this.setState({
      isAboutHotelVisible: !isAboutHotelVisible,
      reviews: newReviewState,
    });
  };

  handleAboutHotelModalOutsideClick = (e) => {
    if (
      this.ablutHotelButtomNode.current.contains(e.target) ||
      this.ablutHotelModalNode.current.contains(e.target)
    ) {
      return;
    }

    this.handleAboutHotelModalClick();
  };

  handleBottomSheetClick = () => {
    const { isTableDetailsVisible, scrollbarWidth } = this.state;

    if (!isTableDetailsVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleBottomSheetOutsideClick,
        false,
      );
      document.addEventListener(
        'keydown',
        this.handleBottomSheetEscPress,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleBottomSheetOutsideClick,
        false,
      );
      document.removeEventListener(
        'keydown',
        this.handleBottomSheetEscPress,
        false,
      );
    }

    this.setState({ isTableDetailsVisible: !isTableDetailsVisible });
  };

  handleBottomSheetEscPress = (e) => {
    if (e.key === 'Escape') {
      this.handleBottomSheetClick();
    }
  };

  handleBottomSheetOutsideClick = (e) => {
    const isSVG =
      e.target.getAttribute('fill') !== null ||
      e.target.getAttribute('width') !== null;

    if (
      this.buttomSheetNode.contains(e.target) ||
      this.detailsButtomNode.contains(e.target) ||
      this.bottomDetailsButtomNode.contains(e.target) ||
      isSVG
    ) {
      return;
    }

    this.handleBottomSheetClick();
  };

  handleFlightsModalClick = () => {
    const { isFlightsModalVisible, scrollbarWidth } = this.state;

    if (!isFlightsModalVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleFlightsModalOutsideClick,
        false,
      );

      this.flightsModalScrollNode.current.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    } else {
      document.removeEventListener(
        'click',
        this.handleFlightsModalOutsideClick,
        false,
      );

      this.timeout(500).then(() => {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      });
    }

    this.setState({
      isFlightsModalVisible: !isFlightsModalVisible,
    });
  };

  handleFlightsModalOutsideClick = (e) => {
    if (
      this.flightsButtomNode.current.contains(e.target) ||
      this.flightsModalNode.current.contains(e.target)
    ) {
      return;
    }

    this.handleFlightsModalClick();
  };

  handleFlightDetailsModalClick = (isToDetFlight) => {
    const { isFlightDetModalVisible, scrollbarWidth } = this.state;
    this.setState({ isToDetFlight });

    if (!isFlightDetModalVisible) {
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = `${scrollbarWidth}px`;

      document.addEventListener(
        'click',
        this.handleFlightDetailModalOutsideClick,
        false,
      );
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      document.removeEventListener(
        'click',
        this.handleFlightDetailModalOutsideClick,
        false,
      );
    }

    this.setState({
      isFlightDetModalVisible: !isFlightDetModalVisible,
    });
  };

  handleFlightDetailModalOutsideClick = (e) => {
    if (
      this.flightDetailModalNode.current.contains(e.target) ||
      this.flightFromDetButtomNode.current.contains(e.target) ||
      this.flightToDetButtomNode.current.contains(e.target)
    ) {
      return;
    }

    this.handleFlightDetailsModalClick(false);
  };

  isTourActualizationReady = () => {
    const { actulizationLoaded, actulizationLoadedSuccess } = this.state;

    return actulizationLoaded && actulizationLoadedSuccess;
  };

  isHotelDetailsReady = () => {
    const { hotelDetailsLoaded, hotelDetailsSuccess } = this.state;

    return hotelDetailsLoaded && hotelDetailsSuccess;
  };

  render() {
    const {
      isPhoneValid,
      phoneErrorMessage,
      emailErrorMessage,
      emailValue,
      isEmailValid,
      emailWasFocused,
      phoneValue,
      dataValid,
      tourInfo,
      promoCode,
      isPromoVisible,
      promoCodeInput,
      tourNote,
      tourNoteVisible,
      isPromoApplied,
      insuranceChecked,
      priceCurrency,
      promoCodeError,

      hotelDetails,
      acualizationData,
      flights,
      ticketsLoaded,
      selectedFlight,
      splitPrice,
      operatorInfo,
      isOnlineBookAvailable,
      isReviewsVisible,
      reviews,
      isAboutHotelVisible,
      selectedAboutHotelCategory,
      isTableDetailsVisible,
      tabletDetailsHeight,
      phoneWasFocused,
      isFlightsModalVisible,
      isFlightDetModalVisible,
      isToDetFlight,
    } = this.state;

    const {
      totalPrice,
      tourPrice,
      insurancePrice,
      // eslint-disable-next-line no-unused-vars
      insurancePriceValue,
      insuranceName,
      promoPrice,
      totalValue,
      discount,
    } = getPrice(
      acualizationData,
      selectedFlight,
      tourInfo,
      this.isInsuranceChecked(),
      promoCode,
    );

    const split = getPriceSplit(acualizationData, operatorInfo);

    return (
      <div className="content">
        <Helmet>
          <title>{`${ORDER_DETAILS_TITLE} ${
            acualizationData.hotelName ? acualizationData.hotelName : ''
          }`}</title>
        </Helmet>
        <div className="containerW">
          <div className="od_breakcrumbs_w">
            <div className="hd_breadcrumbs_link_line">
              <Link className="gm_text_14" to="/">
                {MAIN_PAGE}
              </Link>
              <div className="hd_breadcrumb_delimiter">{SLASH_DELIMITER}</div>
              {acualizationData.countryname ? (
                <Link className="gm_text_14" to="/">
                  {acualizationData.countryname}
                </Link>
              ) : (
                <Skeleton width="500px" height="17px" />
              )}

              <div className="hd_breadcrumb_delimiter">{SLASH_DELIMITER}</div>
              {hotelDetails.name && (
                <div className="gm_text_14">
                  {firstLetterInUpperCase(hotelDetails.name)}
                </div>
              )}
            </div>
          </div>
          {dataValid ? (
            <div>
              <div className="od_title">
                <div>{TOUR_IN}</div>
                &nbsp;
                {this.isHotelDetailsReady() ? (
                  <div>{` ${hotelDetails.region}, ${hotelDetails.country}`}</div>
                ) : (
                  <Skeleton width="500px" height="40px" />
                )}
              </div>

              <div className="od_content_w">
                <div className="od_content_left">
                  <div className="od_tour_details_w">
                    <div className="od_hotel_img_w">
                      <NoHotel />
                      {hotelDetails.images && (
                        <div
                          className="od_hotel_img"
                          style={{
                            backgroundImage: `url("https:${hotelDetails.images[0]}")`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center center',
                            backgroundRepeat: 'no-repeat',
                          }}
                        ></div>
                      )}
                    </div>
                    <div className="od_hotel_info">
                      <div className="od_hotel_info_w2">
                        <div className="od_hotels_stars_w1 mb_15">
                          <div className="od_stars_w">
                            {this.renderHotelCategory(hotelDetails.stars)}
                          </div>
                          <div className="bm_text_22 mb_6">
                            {firstLetterInUpperCase(hotelDetails.name)}
                          </div>
                          <div className="gr_text_14">
                            {this.getHotelLocationName(hotelDetails)}
                          </div>
                        </div>
                        {hotelDetails.rating > 0 && (
                          <div
                            className={`od_hotel_raiting_w ${this.getRatingColor(
                              hotelDetails.rating,
                            )}`}
                          >
                            {hotelDetails.rating}
                          </div>
                        )}
                      </div>
                      <div className="od_tour_hotel_info">
                        {acualizationData.meal && (
                          <div className="mb_8">
                            <span className="bm_text_16">{`${MEAL}: `}</span>
                            <span className="br_text_16">
                              {this.getMeal(acualizationData)}
                            </span>
                          </div>
                        )}

                        {acualizationData.room ? (
                          <div className="mb_8">
                            <span className="bm_text_16">{`${ROOM_TYPE}: `}</span>
                            <span className="br_text_16">
                              {firstLetterInUpperCase(acualizationData.room)}
                            </span>
                          </div>
                        ) : (
                          <div>
                            <Skeleton width="100px" height="14px" />
                          </div>
                        )}

                        {acualizationData.placement ? (
                          <div className="mb_8">
                            <span className="bm_text_16">{`${PLACEMENT}: `}</span>
                            <span className="br_text_16">
                              {acualizationData.placement}
                            </span>
                          </div>
                        ) : (
                          <div>
                            <Skeleton width="110px" height="14px" />
                          </div>
                        )}
                      </div>
                      <div className="od_hotel_buttons_w">
                        {this.isHotelDetailsReady() && (
                          <button
                            ref={(node) => {
                              this.ablutHotelButtomNode.current = node;
                            }}
                            type="button"
                            className="hd_hotel_title_but gray_button"
                            onClick={this.handleAboutHotelModalClick}
                          >
                            {ABOUT_HOTEL}
                          </button>
                        )}

                        {reviews.length > 0 && (
                          <button
                            ref={(node) => {
                              this.reviewModaButtomNode.current = node;
                            }}
                            type="button"
                            className="hd_hotel_title_but gray_button"
                            onClick={this.handleReviewModalClick}
                          >
                            {REVIEWS}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <button
                    type="button"
                    className="od_tour_det_but dbm_text_16"
                    onClick={this.handleBottomSheetClick}
                    ref={(node) => {
                      this.detailsButtomNode = node;
                    }}
                  >
                    {TOUR_DETAILS}
                  </button>

                  <div>
                    <div ref={this.flightsContainer}>
                      {ticketsLoaded ? (
                        this.renderTickets(flights)
                      ) : (
                        <div className="od_flight_wrapper">
                          <FlightLoader />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="od_content_right">
                  <div className="od_order_details_w">
                    <div className="od_tour_details_sections">
                      <div className="od_tour_details_section">
                        <div className="od_tour_details_dot"></div>
                        <div className="bb_text_20 od_section_title">
                          {TOUR_DETAILS}
                        </div>
                        <div className="od_tour_det_w">
                          <div className="mb_20">
                            <div className="od_tour_det_item">
                              <GrayCalendar className="od_tour_det_icon" />
                              {this.isTourActualizationReady() ? (
                                <div className="br_text_16">{`${getDayText(
                                  acualizationData.flydate,
                                )} / ${getNightsText(
                                  acualizationData.nights,
                                )}`}</div>
                              ) : (
                                <Skeleton width="200px" height="15px" />
                              )}
                            </div>
                            <div className="od_tour_det_item">
                              <GrayPerson className="od_tour_det_icon" />
                              {this.isTourActualizationReady() ? (
                                <div className="br_text_16">
                                  {getTouristsTextActualiz(acualizationData)}
                                </div>
                              ) : (
                                <Skeleton width="160px" height="15px" />
                              )}
                            </div>
                          </div>

                          <div className="mb_20">
                            <div className="bb_text_16 mb_4">{OPERATOR}</div>
                            {this.isTourActualizationReady() ? (
                              <div className="br_text_16">
                                {acualizationData.operatorname &&
                                  acualizationData.operatorname}
                              </div>
                            ) : (
                              <Skeleton width="100px" height="15px" />
                            )}
                          </div>

                          <div className="mb_20">
                            <div className="bb_text_16 mb_4">{PROGRAMM}</div>
                            {this.isTourActualizationReady() ? (
                              <div className="br_text_16">
                                {acualizationData.tourname &&
                                  acualizationData.tourname}
                              </div>
                            ) : (
                              <Skeleton width="120px" height="15px" />
                            )}
                          </div>

                          {!this.isRegular(acualizationData) && (
                            <div className="mb_20">
                              <div className="bb_text_16 mb_4">
                                {TOUR_INCLUDED}
                              </div>
                              <div className="br_text_16">
                                <div className="mb_2">{TOUR_INC_AVIA}</div>
                                <div className="mb_2">{TOUR_INC_HOTEL}</div>
                                <div className="mb_2">{TOUR_INC_MED}</div>
                                <div>{TOUR_INC_TRANSFER}</div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="od_tour_details_section">
                        <div className="od_tour_details_dot"></div>
                        <div className="bb_text_20 od_section_title">
                          {PAYMENT}
                        </div>
                        <div className="od_tour_det_w">
                          {split.length > 1 && (
                            <div className="od_payment_section">
                              <div className="bm_text_16">{SPLIT_PRICE}</div>

                              <div className="od_price_split_buttons">
                                {this.renderPriceSplit(split, splitPrice)}
                              </div>

                              <div className="od_split_price">
                                <duv className="od_split_line">
                                  <div className="od_split_pay_title">
                                    {PAY_NOW}
                                  </div>
                                  <div className="od_split_pay_text">
                                    <PriceText
                                      text={`${formatPrice(
                                        this.getSplitPrice(totalValue),
                                      )} ${priceCurrency}`}
                                    />
                                  </div>
                                </duv>
                                <duv className="od_split_line">
                                  <div className="od_split_pay_title">
                                    {PAY_REST}
                                  </div>
                                  <div className="od_split_pay_text">
                                    <PriceText
                                      text={`${formatPrice(
                                        this.getSplitRestPrice(totalValue),
                                      )} ${priceCurrency}`}
                                    />
                                  </div>
                                </duv>
                              </div>
                            </div>
                          )}
                          <div className="od_price_line mb_20">
                            <div className="od_price_line_col od_price_total">
                              {TOTAL}
                            </div>
                            {this.isTourActualizationReady() ? (
                              <div className="od_price_total">
                                <PriceText text={totalPrice} />
                              </div>
                            ) : (
                              <Skeleton width="115px" height="29px" />
                            )}
                          </div>
                          <div className="od_price_line mb_8">
                            <div className="od_price_line_col bm_text_16">
                              {TOUR_PRICE}
                            </div>
                            {isPromoApplied ? (
                              <div className="od_promo_price_w">
                                <div className="od_promo_persent wm_text_14">{`- ${promoCode.value}%`}</div>
                                <div className="bm_text_16 od_promo_price">
                                  <PriceText text={promoPrice} />
                                </div>
                                <div className="gr_text_12 od_promo_tour_price_old">
                                  <PriceText text={tourPrice} />
                                </div>
                              </div>
                            ) : (
                              <div>
                                {this.isTourActualizationReady() ? (
                                  <div className="bm_text_16">
                                    <PriceText text={tourPrice} />
                                  </div>
                                ) : (
                                  <Skeleton width="77px" height="18px" />
                                )}
                              </div>
                            )}
                          </div>
                          {discount && (
                            <div className="od_promo_info mb_8">
                              <div className="greenr_text_14">{DISCOUNT}</div>
                              &nbsp;
                              <div className="greenb_text_14">
                                {promoCode.name}
                              </div>
                              &nbsp;
                              <div className="greenr_text_14">
                                <PriceText text={`- ${discount}`} />
                              </div>
                              &nbsp;
                              <button
                                type="button"
                                onClick={() => {
                                  this.setState({
                                    promoCode: {},
                                    isPromoApplied: false,
                                  });
                                }}
                              >
                                <GreenCross className="od_promo_cross" />
                              </button>
                            </div>
                          )}
                          <div className="od_price_line mb_8">
                            <div className="od_price_line_col bm_text_16">
                              {FUEL_CHARGE}
                            </div>
                            {this.isTourActualizationReady() ? (
                              <div className="od_bold br_text_16">
                                <PriceText text={this.getFuelCharge()} />
                              </div>
                            ) : (
                              <Skeleton width="30px" height="18px" />
                            )}
                          </div>
                          <div className="od_price_line_underline">
                            {this.renderAddPayments()}
                          </div>
                          <div className="od_promo_line">
                            <div className="br_text_16">{I_HAVE_PROMOCODE}</div>
                            <button
                              type="button"
                              onClick={() =>
                                this.setState({
                                  isPromoVisible: !isPromoVisible,
                                })
                              }
                            >
                              {isPromoVisible ? (
                                <ToggleRight />
                              ) : (
                                <ToggleLeft />
                              )}
                            </button>
                          </div>
                          {isPromoVisible && (
                            <div>
                              <div className="od_promo_line">
                                <input
                                  value={promoCodeInput}
                                  className="od_promo_input"
                                  onChange={this.handlePromocodeInput}
                                  placeholder={ENTER_PROMO}
                                />
                                <button
                                  type="button"
                                  className="blue_button od_promo_but wm_text_16"
                                  onClick={this.applyCoupon}
                                  disabled={!this.isTourActualizationReady()}
                                >
                                  {APPLY}
                                </button>
                              </div>
                              {promoCodeError.length > 0 && (
                                <div className="od_promo_error_w">
                                  <div className="rr_text_14">
                                    {promoCodeError}
                                  </div>
                                </div>
                              )}
                            </div>
                          )}

                          <div className="od_note_line">
                            <div className="br_text_16">{ADD_NOTE}</div>
                            <button
                              type="button"
                              onClick={() =>
                                this.setState({
                                  tourNoteVisible: !tourNoteVisible,
                                })
                              }
                            >
                              {tourNoteVisible ? (
                                <ToggleRight />
                              ) : (
                                <ToggleLeft />
                              )}
                            </button>
                          </div>
                          {tourNoteVisible && (
                            <textarea
                              rows={5}
                              value={tourNote}
                              className="od_form_input"
                              onChange={(e) =>
                                this.setState({ tourNote: e.target.value })
                              }
                              placeholder={YOUR_NOTE}
                            />
                          )}

                          {isFlightInsuranceAvailable(
                            acualizationData,
                            operatorInfo,
                          ) && (
                            <div className="od_insurance_line_w">
                              <div className="od_insurance_line">
                                <button
                                  type="button"
                                  onClick={() => {
                                    this.setState({
                                      insuranceChecked: !insuranceChecked,
                                    });
                                  }}
                                >
                                  {insuranceChecked ? (
                                    <ActiveCheck className="od_insurance_check" />
                                  ) : (
                                    <DefaultCheck className="od_insurance_check" />
                                  )}
                                </button>
                                <div>
                                  <div>
                                    <div className="br_text_16">
                                      {FLIGHT_INSURANCE}
                                    </div>
                                    {!insurancePrice && (
                                      <div className="gm_text_14">
                                        {INSUTANCE_MANAGER}
                                      </div>
                                    )}
                                    {insuranceName && (
                                      <div className="gm_text_14">
                                        {insuranceName}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div>
                                {insurancePrice && (
                                  <div className="br_text_16">
                                    <PriceText text={insurancePrice} />
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          {this.renderInsuranceBeforeDays()}
                        </div>
                      </div>
                      <div className="od_tour_details_section">
                        <div className="od_tour_details_dot_last"></div>
                        <div className="bb_text_20 od_section_title">
                          {CONTACT_INFO}
                        </div>
                        <div className="od_tour_det_w">
                          {isOnlineBookAvailable ? (
                            <div>
                              <div className="od_contact_input_w">
                                <input
                                  value={emailValue}
                                  className={`od_contact_input ${
                                    !isEmailValid && emailWasFocused
                                      ? 'od_invalid_input'
                                      : ''
                                  }`}
                                  onChange={this.handleEmailChange}
                                  placeholder={YOUR_EMAIL}
                                  onBlur={this.handleEmailInputBlur}
                                />
                                <div className="rr_text_14 mt_2">
                                  {emailErrorMessage}
                                </div>
                              </div>
                              <div className="od_contact_input_w">
                                <input
                                  value={phoneValue}
                                  className={`od_contact_input ${
                                    !isPhoneValid && phoneWasFocused
                                      ? 'od_invalid_input'
                                      : ''
                                  }`}
                                  onChange={this.handlePhoneChange}
                                  placeholder={CALL_BACK_PHONE}
                                  onBlur={this.handlePhoneInputBlur}
                                  maxLength={13}
                                />
                                <div className="rr_text_14 mt_2">
                                  {phoneErrorMessage}
                                </div>
                              </div>

                              <button
                                type="submit"
                                className={`wm_text_16 ${
                                  isPhoneValid &&
                                  isEmailValid &&
                                  this.isTourActualizationReady()
                                    ? 'od_ckeckout_btn blue_button'
                                    : 'btn_dis'
                                }`}
                                disabled={
                                  !isPhoneValid ||
                                  !isEmailValid ||
                                  !this.isTourActualizationReady()
                                }
                                onClick={() => this.handleCheckoutClick(false)}
                              >
                                {BOOK}
                              </button>
                            </div>
                          ) : (
                            <div>
                              <div className="gr_text_16 mb_14">{`${ONLIBE_BOOK_NOT_AVAIL}.`}</div>
                              <div className="od_contact_but_w">
                                <span
                                  onClick={this.handleContanctUsModal}
                                  className="blue_link od_contact_us_text"
                                >
                                  {CONTACT_US1}
                                </span>
                                <span className="gr_text_16">
                                  {AND_WE_CHECK}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <HotelReviewsModal
                isVisible={isReviewsVisible}
                reviewModalNode={this.reviewModalNode}
                handleReviewModalClick={this.handleReviewModalClick}
                reviews={reviews}
                setReviewsState={(e) => {
                  this.setState({ reviews: e });
                }}
              />

              <AboutHotelModal
                isVisible={isAboutHotelVisible}
                modalNode={this.ablutHotelModalNode}
                handleModalClick={this.handleAboutHotelModalClick}
                hotelDetails={hotelDetails}
                selectedCategory={selectedAboutHotelCategory}
                setSelectedCategory={(category) => {
                  this.setState({ selectedAboutHotelCategory: category });
                }}
              />

              <FlightsModal
                isVisible={isFlightsModalVisible}
                modalNode={this.flightsModalNode}
                scrollNode={this.flightsModalScrollNode}
                handleModalClick={this.handleFlightsModalClick}
                flights={flights}
                cheapestPrice={this.getCheapestPrice()}
                handleSelect={this.selectRoundTrip}
              />

              <FlightsDetailsModal
                isVisible={isFlightDetModalVisible}
                modalNode={this.flightDetailModalNode}
                handleModalClick={(isToDet) =>
                  this.handleFlightDetailsModalClick(isToDet)
                }
                isToDetFlight={isToDetFlight}
                flight={selectedFlight}
              />

              <button
                type="button"
                className="od_tablet_details"
                onClick={this.handleBottomSheetClick}
                ref={(node) => {
                  this.bottomDetailsButtomNode = node;
                }}
              >
                <div className="od_tablet_total_w">
                  <div className="bm_text_26">{TOTAL}</div>
                  <ArrowTop className="od_tablet_arrow_ico" />
                </div>

                <div className="od_tablet_total">
                  <div className="bm_text_26">
                    <PriceText text={totalPrice} />
                  </div>
                  <div className="wr_text_16 od_book_tour">{BOOK_TOUR}</div>
                </div>
              </button>

              <div
                className={`od_bottom-sheet-container ${
                  isTableDetailsVisible ? 'od_tr_open' : ''
                }`}
              >
                <div
                  className="od_bottom-sheet"
                  ref={(node) => {
                    this.buttomSheetNode = node;
                  }}
                  style={{ maxHeight: `${tabletDetailsHeight}px` }}
                >
                  <button
                    type="button"
                    onClick={this.handleBottomSheetClick}
                    className="od_bottom_sh_close"
                  >
                    <Close />
                  </button>
                  <div
                    className="od_bottom_sheet_cointainer blue_scroll_container"
                    style={{ maxHeight: `${tabletDetailsHeight * 0.9}px` }}
                  >
                    <div className="od_tour_details_section">
                      <div className="od_tour_details_dot"></div>
                      <div className="bb_text_20 od_section_title">
                        {TOUR_DETAILS}
                      </div>
                      <div className="od_tour_det_w">
                        <div className="mb_20">
                          <div className="od_tour_det_item">
                            <GrayCalendar className="od_tour_det_icon" />
                            {this.isTourActualizationReady() ? (
                              <div className="br_text_16">{`${getDayText(
                                acualizationData.flydate,
                              )} / ${getNightsText(
                                acualizationData.nights,
                              )}`}</div>
                            ) : (
                              <Skeleton width="200px" height="15px" />
                            )}
                          </div>
                          <div className="od_tour_det_item">
                            <GrayPerson className="od_tour_det_icon" />
                            {this.isTourActualizationReady() ? (
                              <div className="br_text_16">
                                {getTouristsTextActualiz(acualizationData)}
                              </div>
                            ) : (
                              <Skeleton width="160px" height="15px" />
                            )}
                          </div>
                        </div>

                        <div className="mb_20">
                          <div className="bb_text_16 mb_4">{OPERATOR}</div>
                          {this.isTourActualizationReady() ? (
                            <div className="br_text_16">
                              {acualizationData.operatorname &&
                                acualizationData.operatorname}
                            </div>
                          ) : (
                            <Skeleton width="100px" height="15px" />
                          )}
                        </div>

                        <div className="mb_20">
                          <div className="bb_text_16 mb_4">{PROGRAMM}</div>
                          {this.isTourActualizationReady() ? (
                            <div className="br_text_16">
                              {acualizationData.tourname &&
                                acualizationData.tourname}
                            </div>
                          ) : (
                            <Skeleton width="120px" height="15px" />
                          )}
                        </div>

                        {!this.isRegular(acualizationData) && (
                          <div className="mb_20">
                            <div className="bb_text_16 mb_4">
                              {TOUR_INCLUDED}
                            </div>
                            <div className="br_text_16">
                              <div className="mb_2">{TOUR_INC_AVIA}</div>
                              <div className="mb_2">{TOUR_INC_HOTEL}</div>
                              <div className="mb_2">{TOUR_INC_MED}</div>
                              <div>{TOUR_INC_TRANSFER}</div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="od_tour_details_section">
                      <div className="od_tour_details_dot"></div>
                      <div className="bb_text_20 od_section_title">
                        {PAYMENT}
                      </div>
                      <div className="od_tour_det_w">
                        {split.length > 1 && (
                          <div className="od_payment_section">
                            <div className="bm_text_16">{SPLIT_PRICE}</div>

                            <div className="od_price_split_buttons">
                              {this.renderPriceSplit(split, splitPrice)}
                            </div>

                            <div className="od_split_price">
                              <duv className="od_split_line">
                                <div className="bm_text_16">{PAY_NOW}</div>
                                <div className="br_text_16">
                                  <PriceText
                                    text={`${formatPrice(
                                      this.getSplitPrice(totalValue),
                                    )} ${priceCurrency}`}
                                  />
                                </div>
                              </duv>
                              <duv className="od_split_line">
                                <div className="bm_text_16">{PAY_REST}</div>
                                <div className="br_text_16">
                                  <PriceText
                                    text={`${formatPrice(
                                      this.getSplitRestPrice(totalValue),
                                    )} ${priceCurrency}`}
                                  />
                                </div>
                              </duv>
                            </div>
                          </div>
                        )}
                        <div className="od_price_line mb_20">
                          <div className="od_price_line_col od_price_total">
                            {TOTAL}
                          </div>
                          {this.isTourActualizationReady() ? (
                            <div className="od_price_total">
                              <PriceText text={totalPrice} />
                            </div>
                          ) : (
                            <Skeleton width="115px" height="29px" />
                          )}
                        </div>
                        <div className="od_price_line mb_8">
                          <div className="od_price_line_col bm_text_16">
                            {TOUR_PRICE}
                          </div>
                          {isPromoApplied ? (
                            <div className="od_promo_price_w">
                              <div className="od_promo_persent wm_text_14">{`- ${promoCode.value}%`}</div>
                              <div className="bm_text_16 od_promo_price">
                                <PriceText text={promoPrice} />
                              </div>
                              <div className="gr_text_12 od_promo_tour_price_old">
                                <PriceText text={tourPrice} />
                              </div>
                            </div>
                          ) : (
                            <div>
                              {this.isTourActualizationReady() ? (
                                <div className="bm_text_16">
                                  <PriceText text={tourPrice} />
                                </div>
                              ) : (
                                <Skeleton width="77px" height="18px" />
                              )}
                            </div>
                          )}
                        </div>
                        {discount && (
                          <div className="od_promo_info mb_8">
                            <div className="greenr_text_14">{DISCOUNT}</div>
                            &nbsp;
                            <div className="greenb_text_14">
                              {promoCode.name}
                            </div>
                            &nbsp;
                            <div className="greenr_text_14">
                              <PriceText text={`- ${discount}`} />
                            </div>
                            &nbsp;
                            <button
                              type="button"
                              onClick={() => {
                                this.setState({
                                  promoCode: {},
                                  isPromoApplied: false,
                                });
                              }}
                            >
                              <GreenCross className="od_promo_cross" />
                            </button>
                          </div>
                        )}
                        <div className="od_price_line mb_8">
                          <div className="od_price_line_col bm_text_16">
                            {FUEL_CHARGE}
                          </div>
                          {this.isTourActualizationReady() ? (
                            <div className="od_bold br_text_16">
                              <PriceText text={this.getFuelCharge()} />
                            </div>
                          ) : (
                            <Skeleton width="30px" height="18px" />
                          )}
                        </div>
                        <div className="od_price_line_underline">
                          {this.renderAddPayments()}
                        </div>

                        <div className="od_note_w">
                          {/* promo */}
                          <div className="od_promo_col">
                            <div className="od_promo_line">
                              <div className="br_text_16">
                                {I_HAVE_PROMOCODE}
                              </div>
                              <button
                                type="button"
                                onClick={() =>
                                  this.setState({
                                    isPromoVisible: !isPromoVisible,
                                  })
                                }
                              >
                                {isPromoVisible ? (
                                  <ToggleRight />
                                ) : (
                                  <ToggleLeft />
                                )}
                              </button>
                            </div>
                            {isPromoVisible && (
                              <div className="mb_10">
                                <div className="od_promo_line">
                                  <input
                                    value={promoCodeInput}
                                    className="od_promo_input"
                                    onChange={this.handlePromocodeInput}
                                    placeholder={ENTER_PROMO}
                                  />
                                  <button
                                    type="button"
                                    className="blue_button od_promo_but wm_text_16"
                                    onClick={this.applyCoupon}
                                    disabled={!this.isTourActualizationReady()}
                                  >
                                    {APPLY}
                                  </button>
                                </div>
                                {promoCodeError.length > 0 && (
                                  <div className="od_promo_error_w">
                                    <div className="rr_text_14">
                                      {promoCodeError}
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}

                            {isFlightInsuranceAvailable(
                              acualizationData,
                              operatorInfo,
                            ) && (
                              <div className="od_insurance_line_w">
                                <div className="od_insurance_line">
                                  <button
                                    type="button"
                                    onClick={() => {
                                      this.setState({
                                        insuranceChecked: !insuranceChecked,
                                      });
                                    }}
                                  >
                                    {insuranceChecked ? (
                                      <ActiveCheck className="od_insurance_check" />
                                    ) : (
                                      <DefaultCheck className="od_insurance_check" />
                                    )}
                                  </button>
                                  <div>
                                    <div>
                                      <div className="br_text_16">
                                        {FLIGHT_INSURANCE}
                                      </div>
                                      {!insurancePrice && (
                                        <div className="gm_text_14">
                                          {INSUTANCE_MANAGER}
                                        </div>
                                      )}
                                      {insuranceName && (
                                        <div className="gm_text_14">
                                          {insuranceName}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  {insurancePrice && (
                                    <div className="br_text_16">
                                      <PriceText text={insurancePrice} />
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            {this.renderInsuranceBeforeDays()}
                          </div>

                          {/* note */}
                          <div className="od_promo_col">
                            <div className="od_note_line">
                              <div className="br_text_16">{ADD_NOTE}</div>
                              <button
                                type="button"
                                onClick={() =>
                                  this.setState({
                                    tourNoteVisible: !tourNoteVisible,
                                  })
                                }
                              >
                                {tourNoteVisible ? (
                                  <ToggleRight />
                                ) : (
                                  <ToggleLeft />
                                )}
                              </button>
                            </div>

                            {tourNoteVisible && (
                              <textarea
                                rows={5}
                                value={tourNote}
                                className="od_form_input"
                                onChange={(e) =>
                                  this.setState({ tourNote: e.target.value })
                                }
                                placeholder={YOUR_NOTE}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="od_tour_details_section">
                      <div className="od_tour_details_dot_last"></div>
                      <div className="bb_text_20 od_section_title">
                        {CONTACT_INFO}
                      </div>
                      <div className="od_tour_det_w">
                        {isOnlineBookAvailable ? (
                          <div>
                            <div className="od_tablet_contact">
                              <div className="od_tablet_contact_input_w">
                                <input
                                  value={emailValue}
                                  className={`od_tablet_contact_input ${
                                    !isEmailValid && emailWasFocused
                                      ? 'od_invalid_input'
                                      : ''
                                  }`}
                                  onChange={this.handleEmailChange}
                                  placeholder={YOUR_EMAIL}
                                  onBlur={this.handleEmailInputBlur}
                                />
                              </div>
                              <div className="od_tablet_contact_input_w">
                                <input
                                  value={phoneValue}
                                  className={`od_tablet_contact_input ${
                                    !isPhoneValid && phoneWasFocused
                                      ? 'od_invalid_input'
                                      : ''
                                  }`}
                                  onChange={this.handlePhoneChange}
                                  placeholder={CALL_BACK_PHONE}
                                  onBlur={this.handlePhoneInputBlur}
                                  maxLength={13}
                                />
                              </div>
                            </div>
                            <div className="od_tablet_error_w">
                              <div className="rr_text_14 mt_2">
                                {emailErrorMessage}
                              </div>
                              <div className="rr_text_14 mt_2">
                                {phoneErrorMessage}
                              </div>
                            </div>
                            <button
                              type="submit"
                              className={`wm_text_16 ${
                                isPhoneValid &&
                                isEmailValid &&
                                this.isTourActualizationReady()
                                  ? 'od_ckeckout_btn blue_button'
                                  : 'btn_dis'
                              }`}
                              disabled={
                                !isPhoneValid ||
                                !isEmailValid ||
                                !this.isTourActualizationReady()
                              }
                              onClick={() => this.handleCheckoutClick(true)}
                            >
                              {BOOK}
                            </button>
                          </div>
                        ) : (
                          <div>
                            <div className="gr_text_16 mb_14">{`${ONLIBE_BOOK_NOT_AVAIL}.`}</div>
                            <div className="od_contact_but_w">
                              <span
                                onClick={this.handleContanctUsModal}
                                className="blue_link od_contact_us_text"
                              >
                                {CONTACT_US1}
                              </span>
                              <span className="gr_text_16">{AND_WE_CHECK}</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="od_not_found_w">
              <div className="od_not_found">
                <img src={NoResults} alt="" className="mb_5" />
                <div className="br_text_18">{TOUR_DATA_OUTDATED}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

OrderDetails.propTypes = {
  location: PropTypes.instanceOf(Object).isRequired,
  navigate: PropTypes.func.isRequired,
  changeContactModalVisible: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, {
  changeContactModalVisible,
})(OrderDetails);
